import { useCallback, useState } from 'react'

export type LocationPermissionStatus =
    | 'always'
    | 'whenInUse'
    | 'denied'
    | 'notDetermined'
    | 'restricted'
    | 'unknown'

export function useDeviceTrackingSettings() {
    const [deviceTrackingDisabled, setDeviceTrackingDisabledState] = useState(true)

    const setDeviceTrackingDisabled = useCallback(async (_value: boolean) => {
        setDeviceTrackingDisabledState(_value)
    }, [])

    return {
        deviceTrackingDisabled,
        setDeviceTrackingDisabled,
        locationPermissionStatus: 'unknown' as LocationPermissionStatus,
        isLoading: false,
        showPermissionWarning: false,
    }
}
